<template>
  <v-container class="pa-0">
   <v-row class="col-sm-12 col-md-12 col-12 pr-0 mr-0">
      <v-spacer></v-spacer>
      <v-col class="d-flex justify-end pb-2 px-0 mb-0" cols="4" sm="6" xs="12">
        <v-btn 
            v-if="!!parametrizacao && parametrizacao.RG_ANEXO_TISS"
            color="primary"
            depressed
            outlined
            height="30px"
            small
            class="px-2 mr-2 mb-0 mt-2"
            @click="OpenAnexosDlg()"
          > Adicionar anexos
        </v-btn>
        <v-btn 
            v-if="!!parametrizacao && parametrizacao.RG_ANEXO_TISS"
            color="primary"
            class="px-2 mr-2 mb-0 mt-2"
            height="30px"
            text
             @click="liberarEnvioAnexosConfirm()"
          > 
          <v-icon small class="pr-2">fas fa-paper-plane</v-icon>
          Liberar envio
        </v-btn>
      </v-col>
    </v-row>
  <v-row class="col-sm-12 col-md-12 col-12 pr-0 mr-0 pt-0 mt-0">
    <v-col col=12 class="px-0 mx-0 pt-0 mt-0">

    <v-data-table
      :headers="headers"
      :items="list"
      hide-default-footer                     
      :class="['lotesRecursadosTable', 'elevation-0' ]"
      dense
      :items-per-page="pagination.limit"
    >
      <template v-slot:item.arq_nome="{ item }"> 
        <b>{{item.arq_nome}}</b>
      </template>
    
      <template class="center" v-slot:item.status_envio="{ item }">
      <span>
        <v-tooltip center bottom>
          <template v-slot:activator="{ on, attrs }">
             <v-icon 
                class="icon_size"
                style="font-size 15px"
                v-bind="attrs"
                v-on="on"
                :color="getColor(item)"  
              >fa-circle</v-icon
            >
            
          </template>
          <span class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
          >{{getDescription(item)}}
          </span>
        </v-tooltip>
        <v-btn v-if="(item.status_envio == -1 || item.critica_ignorada)" color="primary" height="30px" small depressed icon @click="()=>{dadosAnexo=item;showErroDlg=true}">        
        <v-icon 
                class="icon_size"
                style="font-size: 15px"
                :color="item && item.critica_ignorada? '#118aca':'#D0021B'"  
              >far fa-eye
            </v-icon> 
        </v-btn>
      </span>        
      </template>
      <template v-slot:item.tipo_documento="{ item }">  
        <b>{{tipoDocumentoTISS[item.tipo_documento]}} </b>
      </template>

      <template v-slot:item.protocolo_envio="{ item }">
        <b  v-if="!envio_manual">{{item.protocolo_envio}}</b>
        <v-text-field 
          v-else
          dense
          type="text"
          v-model="item.protocolo_envio"
          flat
          :rules="[formRules.max20]"
          @input="exibirSalvar=true"
          class="mb-n5 input-no-border"
          >
        </v-text-field>
        <v-menu left offset-x :nudge-width="250" max-width="250px" v-if="(((!item.protocolo_envio || item.protocolo_envio == '') && item.protocolo_envio_guias && item.protocolo_envio_guias.length) || (item.protocolo_envio_itens && item.protocolo_envio_itens.length)) && getMostra(item)">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small color="primary" icon>
              <v-icon small color="primary">fa-eye</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-text>
              <p v-if="item.protocolo_envio_guias && item.protocolo_envio_guias.length">
              <b>Protocolo das guias:</b><br>
                {{item.protocolo_envio_guias}} 
              </p>
              <p v-if="item.protocolo_envio_itens && item.protocolo_envio_itens.length">
                <b>Protocolo dos itens:</b><br>
                {{item.protocolo_envio_itens}}
              </p>
            </v-card-text>
          </v-card>
        </v-menu>
      </template>
      <template v-slot:item.numero_lote="{ item }">  
        <b>{{ item.numero_lote != null && item.numero_lote != '' ? item.numero_lote : ' - ' }}  / {{ item.numero_guia != null && item.numero_guia != '' ? item.numero_guia : ' - ' }} </b>
      </template>
      <template v-slot:item.codigo_procedimento="{ item }">  
        <b>{{ item.codigo_procedimento != null && item.codigo_procedimento != '' ? item.codigo_procedimento : ' - ' }} </b>
      </template>
          <template v-slot:item.data_envio="{ item }" >
              <b v-if="!envio_manual">{{item.dataEnvio | formatDateTime}}</b>
              <v-menu 
                  v-else
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  width="120"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    v-model="item.dataEnvio"
                    format="DD/MM/YYYY"
                    v-mask="'##/##/####'"
                    dense
                    flat
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    @blur="item.data_envio = parseDate(item.dataEnvio)"
                    class="mb-n5 input-no-border"
                    :rules="[formRules.typeDateFormated]"
                  ></v-text-field>
                  </template>
                  <v-date-picker 
                    v-model="item.data_envio"
                    no-title
                    @input="item.dataEnvio = formatDate(item.data_envio); exibirSalvar=true"
                    >
                  </v-date-picker>
            </v-menu>
      </template>
      <template v-slot:item.data_atualizacao="{ item }">
        {{ item.data_atualizacao | formatDateTime }}
      </template>
      <template v-slot:item.erro_mensagem="{ item }">
        <template v-if="item.codigo_erro_tiss && item.codigo_erro_tiss.length 
        && item.descricao_erro_tiss && item.descricao_erro_tiss.length">
        {{ item.codigo_erro_tiss }} {{item.descricao_erro_tiss}}
        </template>
        <template v-else>
          <template v-if="item.erro_mensagem && item.erro_mensagem.length">
            {{item.erro_mensagem}}
          </template>
        </template>
      </template>
      <template v-slot:item.docs="{ item }">
        <v-tooltip bottom open-delay="100" v-if="!!item.doc_id">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="primary"
              small
              v-bind="attrs"
              v-on="on"
              @click="download({ doc_id: item.doc_id})"
              >fa-download
            </v-icon>
          </template>
          <span
            class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
            >Download do arquivo</span
          >
        </v-tooltip>
        <v-tooltip bottom open-delay="100" v-if="!!item.doc_id_protocolo">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="primary"
              small
              v-bind="attrs"
              v-on="on"
              @click="download({ doc_id: item.doc_id_protocolo })"
              >fa-file-contract
            </v-icon>
          </template>
          <span
            class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
            >Protocolo de envio</span
          >
        </v-tooltip>
        <v-tooltip bottom open-delay="100" v-if="item.status_envio < 1 && !!parametrizacao && parametrizacao.RG_ANEXO_TISS">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="primary"
              small
              v-bind="attrs"
              v-on="on"
              @click="openEdicaoDlg(item)"
              >fa-pencil-alt
            </v-icon>
          </template>
          <span
            class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
            >Editar dados do anexo</span
          >
        </v-tooltip>
        <v-tooltip bottom open-delay="100" v-if="item.status_envio < 1 && !!parametrizacao && parametrizacao.RG_ANEXO_TISS">
          <template v-slot:activator="{ on, attrs }">
            <v-icon 
                  class="icon_size"
                  style="font-size 15px"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="confirmarExclusao(item)"
                >fa fa-trash-alt
            </v-icon> 
          </template>
          <span
            class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
            >Excluir arquivo</span
          >
        </v-tooltip>
        <v-tooltip bottom open-delay="100" v-else>
          <template v-slot:activator="{ on, attrs }">
            <v-icon 
                  class="icon_size"
                  style="font-size 15px"
                  color="grey"
                  v-bind="attrs"
                  v-on="on"
                >fa fa-trash-alt
            </v-icon> 
          </template>
          <span
            class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
            >Não é possivel excluir este arquivo</span
          >
        </v-tooltip>
      </template>
    </v-data-table>
    <template>
      <div style="margin-top: 30px" class="text-center py-0 col-md-12">
        <v-pagination
          class="no-box-shadow"
          v-model="page"
          :length="pagination.total_pages"
          @input="
            filterList( filterData, page )
          "
        ></v-pagination>
      </div>
    </template>
      <ErroDlg 
      :close=" () => closeErros()"
      :dialog="showErroDlg"
      :info="dadosAnexo"
      :dadosPagamento="dadosPagamento"
      :grupoEconomico="grupoEconomico"
      :updatePage="()=>filterList(filterData, page)"
      />
      <AnexosViewDlg
      :close="
        () => {
          filterList(filterData, page);
          showAnexosViewDlg = false;
        }
      "
      :dialog="showAnexosViewDlg"
      :downloadRecurso="() => {}"
      :grupoEconomico="grupoEconomico"
      :dadosPagamento="dadosPagamento"
      :updatePage="filterList"
      :parametros="parametrizacao"
    />
    <AnexoEdicaoDlg
      :close="() =>{itemSelecionado = {}; showAnexoEdicaoDlg = false;}"
      :dialog="showAnexoEdicaoDlg"
      :grupoEconomico="grupoEconomico"
      :dadosPagamento="dadosPagamento"
      :parametros="parametrizacao"
      :itemSelecionado="itemSelecionado"
      :updateItem="(anexo)=>{itemSelecionado = anexo}"
    />
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
moment.locale("pt-BR");
import { mapState } from "vuex";
import ErroDlg from '@/components/recebiveis/acompanhamento_de_envio/ErroAnexoDlg'
import AnexosViewDlg from '@/components/recebiveis/recursos_de_glosa/AnexosViewDlg';
import AnexoEdicaoDlg from '@/components/recebiveis/acompanhamento_de_envio/AnexoEdicaoDlg';
export default {
  components: {
    ErroDlg,
    AnexosViewDlg,
    AnexoEdicaoDlg
  },
  data() {
    return {
      count: 0,
      dadosAnexo:{},
      exibirSalvar: false,
      filter: {
        grupo_economico: this.grupoEconomico, 
        recurso_guia_id: null, 
        pagamento_id: null, 
        status_envio: null 
        },
      headers:[
        { text: "Nome do arquivo", align: "left", class: "alt_header", value: "arq_nome", sortable: false, },
        //{ text: "Ident. na operadora", value: "identificador_prestador", align: "center", sortable: false, },
        { text: "Tipo do documento", value: "tipo_documento", align: "center", sortable: false, },
        { text: "Nº do Lote/Guia", value: "numero_lote", align: "center", sortable: false, },
        { text: "Cód. Procedimento", value: "codigo_procedimento", align: "center", sortable: false, },
        { text: "Protocolo envio", value: "protocolo_envio", align: "center", sortable: false },
        { text: "Data envio", value: "data_envio", align: "center", sortable: false },
        { text: "Retorno da Operadora", value: "erro_mensagem", align: "center", sortable: false},
        { text: "Status", align: "center", class: "alt_header", value: "status_envio", sortable: false },
        { text: "Ações", value: "docs", align: "center", sortable: false },
      ],
      itemSelecionado: {},
      listaItens: [],      
      envio_digitacao_robo: false,
      page: 1,
      pageCount: 0,
      paginationItens: {
        current_page: 1,
        offset: 1,
        total_pages: 0,
        limit: 5
      },
      statusPgto: null,
      showAnexosViewDlg: false,
      showAnexoEdicaoDlg: false,
      showErroDlg: false,
      showModal: false,
      tipoDocumentoTISS: {
        "01":"Comprovante de elegibilidade",
        "02":"Laudo do profissional de saúde",
        "03":"Pedido do profissional de saúde",
        "04":"Relatório do profissional de saúde",
        "05":"Prescrição do profissional de saúde",
        "06":"Comprovante de comparecimento (assinatura)",
        "07":"Embalagem/rótulo de materiais e/ou medicamentos",
        "08":"Comprovante de entrega de medicamentos",
        "09":"Notas fiscais",
        "10":"Boletim anestésico",
        "11":"Selos hemoterápicos",
        "12":"Exames de imagem",
        "13":"Exames de análises clínicas",
        "14":"Termo de consentimento",
        "15":"Guia de cobrança de taxa",
        "16":"Autorização prévia",
        "17":"Relatório de Auditoria" 
      },
    }
    },
    watch:{
      list:{
        deep: true,
        handler(){
          let ind = this.headers.findIndex( item => item.value == "protocolo_envio")
          if(!!this.parametrizacao && !this.parametrizacao.RG_ANEXO_TISS && ind > -1){
            this.headers.splice(ind, 4)
          } else if(!!this.parametrizacao && this.parametrizacao.RG_ANEXO_TISS && ind == -1) {
            let newind = this.headers.length -1
            this.headers.splice(newind, 0, 
                    { text: "Protocolo envio", value: "protocolo_envio", align: "center", sortable: false },
                    { text: "Data envio", value: "data_envio", align: "center", sortable: false },
                    { text: "Retorno da Operadora", value: "mensagens", align: "center", sortable: false},
                    { text: "Status", align: "center", class: "alt_header", value: "status_envio", sortable: false })
          }
        this.$nextTick()
        this.page = this.pagination.current_page
        }
      }
    },
    computed: {
      ...mapState({
        grupoEconomico: (state) => state.permissions.grupoEconomico,
        formRules: (state) => state.formRules,
        userData: (state) => state.userData
      }),
    },
    mounted() {
       let ind = this.headers.findIndex( item => item.value == "protocolo_envio")
          if(!!this.parametrizacao && !this.parametrizacao.RG_ANEXO_TISS && ind > -1){
            this.headers.splice(ind, 4)
          } else if(!!this.parametrizacao && this.parametrizacao.RG_ANEXO_TISS && ind == -1) {
            let newind = this.headers.length -1
            this.headers.splice(newind, 0, 
                    { text: "Protocolo envio", value: "protocolo_envio", align: "center", sortable: false },
                    { text: "Data envio", value: "data_envio", align: "center", sortable: false },
                    { text: "Retorno da Operadora", value: "mensagens", align: "center", sortable: false},
                    { text: "Status", align: "center", class: "alt_header", value: "status_envio", sortable: false })
          }
    },
    methods: {
      closeErros(){
        this.filterList(this.filterData, this.page);
        this.showErroDlg = false;
      },
      confirmarExclusao(item){
      let paramModal = {
        type: "warning",
        title: "EXCLUIR ARQUIVO!",
        message: 'Não será possivel desfazer essa operação',
        callback: () => this.excluir(item),
        btConfirm: { name: "confirmar", show: true, },
        btCancel: { name: 'Cancelar', show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
    },
    excluir(item){
      let {data_pagamento, prestador_id, operadora_ans_id} =  this.dadosPagamento
      let payload = { grupo_economico: this.grupoEconomico, id: item.id, data_pagamento, prestador_id, operadora_ans_id, fluxo_envio_anexo: true}
      let obj = {query: [{Modulo: "Recebiveis", Acao: "DeleteAnexoRecursoUpload", Payload: payload}]}
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        this.filterList(this.filterData, this.page);
      })
    },
     downloadDocument(tipo, pagamento) {
      let acao = "downloadrecursoglosa";
      let Payload = {
        doc_id: pagamento["doc_id_" + tipo],
        pagamento_id: pagamento.id,
        grupo_economico: this.grupoEconomico,
        tipo,
      };
      this.getDocumentPost({
        Payload,
        acao,
        callback: setTimeout(() => {
          this.filterList(this.filterData, this.page);
        }, 5000),
      });
    },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split("T")[0].split('-')
        return `${day}/${month}/${year}`
      },
      getMostra(item){
        let param =  this.filterData.tipo_consulta == 'lotes' ? 'status_id' : 'status_envio'

        return item[param] == 2 ? false : true

      },
      getColor(item){
          let status = this.estadoList.find(el => el.id == item.status_envio)
          return status ? status.color : '#FFF'     
      },
      getDescription(item){
          let status = this.estadoList.find(el => el.id == item.status_envio)
          return status ? status.descricao : ''   
      },
      parseDate (date) {
          if (!date) return null
          const [day, month, year] = date.split('/')
          return `${year}-${month}-${day}`
      },
      download(docData) {
        let Payload = {
          grupo_economico: this.grupoEconomico,
          pagamento_id: this.dadosPagamento.id,
          ...docData,
        };
        this.$store.dispatch("documents/getDocument", Payload, {
          root: true,
        });
      },
      liberarEnvioAnexosConfirm(){
        let paramModal = {
        type: "warning",
        title: "Liberar anexos!",
        message: 'Deseja liberar todos os anexos prontos para envio?',
        callback: () => this.liberarEnvioAnexos(),
        btConfirm: { name: "confirmar", show: true, },
        btCancel: { name: 'Cancelar', show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
      },
      liberarEnvioAnexos(){
        let Payload = {
          grupo_economico: this.grupoEconomico,
          pagamento_id: this.dadosPagamento.id
        };
        let obj = {query: [{Modulo: "Recebiveis", Acao: "LiberarEnvioAnexoRecurso", Payload}]}
        this.$store.dispatch("request/doRequest", obj).then((response) => {
          if (!response || response.isAxiosError || !response.sucesso) {
            this.$store.commit("hideLoader");
            return;
          }
          let paramModal = {
            type: "success",
            title: "Sucesso!",
            message: response.mensagem,
            callback: ()=>this.filterList(this.filterData, this.page),
            btConfirm: { name: "Ok", show: true },
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          
        })
      },
      OpenAnexosDlg(){
        this.showAnexosViewDlg = true
      },
      openEdicaoDlg(item){
        this.itemSelecionado = item;
        this.showAnexoEdicaoDlg = true;
      },
      viewguias(lote) {
        let numero_lote = lote
        let tipo_consulta = 'guias'
        this.filterList({...this.filterData, numero_lote, tipo_consulta});
      },
    },
  props: {
    dadosPagamento: Object,
    envio_manual: Boolean,
    estadoList: Array,
    exibirNivelGuia: Boolean,
    filterData: Object,
    filterList: Function,
    list: Array,
    pagination: Object,
    parametrizacao: Object,
    protocolo_pagamento: Object,
    tipo_protocolo: String
  },
};
</script>
<style lang="scss">
    .alt_header {
      height: 45px !important;
    }
    .icon_size{
        font-size: 14px !important;
    }

.text-list {
  font-size: 13px;
  line-height: 1.15em;
}
.text-list.space {
  margin-right: 3px;
}
.text-list.pres {
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable,
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable.table-guias {
  min-width: 100%;
  width: 100%;
  max-width: 100%;
}
.lotesRecursadosTable.envio_manual {
  .v-data-table__wrapper > table > tbody > tr td:nth-child(6), 
  .v-data-table__wrapper > table > tbody > tr td:nth-child(7) {
    background-color: rgba(207, 212, 3, .10) !important;
    min-width: 120px;
  }
}
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable  tr th,
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable  tr td {
    padding: 0 auto;
}
// .lotesRecursadosTable {
//   .v-data-table__wrapper > table > tbody > tr td:nth-child(7){
//     min-width: 12%;
//   }
// }
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable tr td:nth-child(1),
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable tr td:nth-child(2),
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable tr td:nth-child(8),
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable tr td:nth-child(9) {
    white-space: nowrap !important;
    padding: 0 6px;
}

.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:last-child,
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:last-child {
  position: sticky !important;
  right: 0;
  /* Displayed on top of other rows when scrolling */
  z-index: 3;
}
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:first-child,
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:first-child {
  position: sticky !important;
  left: 0;
  z-index: 3;
  
}
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:nth-child(2),
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:nth-child(2)   {
  position: sticky !important;
  left: 47px;
  /* Displayed on top of other rows when scrolling 1*/
  z-index: 3;
  //min-width: 54px
}

.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:nth-child(3),
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:nth-child(3)   {
  position: sticky !important;
  left: 110px;
  /* Displayed on top of other rows when scrolling */
  /*trava a coluna */ 
  z-index: 3;
}

.no-box-shadow, .no-box-shadow *{
  box-shadow: 0 0 0 0!important;
}

.lotesRecursadosTable.table-guias .v-data-table__wrapper > table {
  border-collapse: separate;
}
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:first-child,
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:nth-child(2),

.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:nth-child(3),
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:last-child {
  background-color: #eff3f8;
  padding-left: 8px;
  padding-right: 8px;
}
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:first-child, 
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:nth-child(2),
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:nth-child(3),
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:last-child {
  background-color: rgb(255, 255, 255);
  padding-left: 8px;
  padding-right: 8px;
}



</style>

